import { VoiceEmotion } from '@app/interfaces/record-transcription';
export const DEFAULT_EMOTION: VoiceEmotion = { tag: 'neutral', score: 0.1 };
export const EMOTION_COLORS_PALLET: Record<VoiceEmotion['tag'], Array<number>> = {
  neutral: [192, 192, 192],
  negative: [239, 67, 83],
};
export function emotionToColorConverter(emotion: VoiceEmotion) {
  return `rgb(${EMOTION_COLORS_PALLET[emotion.tag].join(' ')} / ${emotion.score})`;
}
